import { render, staticRenderFns } from "./corporate-risk-view.vue?vue&type=template&id=e3a7f0d8&scoped=true"
import script from "./corporate-risk-view.vue?vue&type=script&lang=js"
export * from "./corporate-risk-view.vue?vue&type=script&lang=js"
import style0 from "./corporate-risk-view.vue?vue&type=style&index=0&id=e3a7f0d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a7f0d8",
  null
  
)

export default component.exports